import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatedChecklist } from '@modeso/aumico-lib-annualreport-fe';
import { EMPTY_ARRAY_LENGTH, IAumMenuItem, IAumMenuItemPerRow } from '@modeso/aumico-lib-core-fe';

import { FormBuilder, FormGroup } from '@angular/forms';
import { I18NextService } from 'angular-i18next';
import { ChecklistActions } from '../../enums/checklist-actions.enum';

@Component({
    selector: 'checklist-table-new',
    templateUrl: './checklist-table-new.component.html',
    styleUrls: ['./checklist-table-new.component.scss'],
})
export class ChecklistTableNewComponent implements OnInit {
    public tableData: TranslatedChecklist[];
    @Input() set checklists(value: TranslatedChecklist[]) {
        this.tableData = value;
        this.applyFilter();
    }

    @Output() onEditChecklist = new EventEmitter<TranslatedChecklist>();
    @Output() onCopyChecklist = new EventEmitter<TranslatedChecklist>();
    @Output() onDeleteChecklist = new EventEmitter<string[]>();
    @Output() search = new EventEmitter<string>();
    @Output() addNewChecklistClicked = new EventEmitter<void>();

    private selectedRows: TranslatedChecklist[] = [];
    private _filterText: string = '';
    public filteredData: TranslatedChecklist[];
    private selectedChecklistsIds: string[] = [];

    public menuItems: IAumMenuItem[] = [];

    get filterText(): string {
        return this._filterText;
    }

    set filterText(value: string) {
        this._filterText = value.toLowerCase();
        this.applyFilter();
    }

    searchForm: FormGroup;

    constructor(private readonly fb: FormBuilder, private readonly i18n: I18NextService) {}

    onMenuItemPerRowClick(action: string, row: any, item?: IAumMenuItemPerRow, event?: Event): void {
        if (action == ChecklistActions.EDIT) {
            this.onEditChecklist.emit(row);
        } else if (action == ChecklistActions.COPY) {
            this.onCopyChecklist.emit(row);
        }
    }

    public copyChecklist(row): void {
        this.onCopyChecklist.emit(row);
    }

    public editChecklist(row): void {
        this.onEditChecklist.emit(row);
    }

    public onMenuItemClicked(action: string): void {
        if (
            action === ChecklistActions.DELETE &&
            this.selectedRows != null &&
            this.selectedRows.length > EMPTY_ARRAY_LENGTH
        ) {
            this.selectedRows.forEach((selectedChecklist: TranslatedChecklist) => {
                this.selectedChecklistsIds.push(selectedChecklist.id);
            });
            this.onDeleteChecklist.emit(this.selectedChecklistsIds);
        }
    }

    ngOnInit(): void {
        this.applyFilter();
        this.searchForm = this.fb.group({
            searchTerm: [''],
        });
        this.getMenuOptions();
    }

    private getMenuOptions(): void {
        this.menuItems = [
            {
                caption: this.i18n.t('aumico_button_delete') as string,
                action: ChecklistActions.DELETE,
                icon: 'assets/hamIcons/trash-outline.svg',
            },
        ];
    }

    filterItems(): void {
        this.filterText = this.searchForm.get('searchTerm').value;
        this.applyFilter();
        this.search.emit();
    }

    public resetFilter(): void {
        this.filterText = '';
    }

    private applyFilter(): void {
        if (this._filterText) {
            this.filteredData = this.tableData.filter((item) => item.name.toLowerCase().includes(this._filterText));
        } else {
            this.filteredData = [...this.tableData];
        }
    }

    public addNewChecklist(): void {
        this.addNewChecklistClicked.emit();
    }

    public onCheckBoxSelectionChanged(selectedRows: TranslatedChecklist[]): void {
        this.selectedRows = selectedRows;
        this.selectedChecklistsIds = [];
    }
}
